module.exports = __webpack_public_path__ + "img/frame_IELTS_money.b14b65a4.svg";